import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const ElementaryLessons = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              Kindergarten to Grade 6
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex'>
              <p className='text-black sm:text-justify md:text-xl'>
                Kindergarten to grade 6 Elementary students. Our custom made
                programs are ideal for students in both public and private
                schools. Link and Learn centres their customized approach for
                elementary school students on emphasizing and reinforcing the
                fundamentals of conversation skills, oral reading, reading
                comprehension, writing and mathematics.
              </p>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/elementary.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ElementaryLessons;
